import { render, staticRenderFns } from "./StTable.vue?vue&type=template&id=48d6da0e"
import script from "./StTable.vue?vue&type=script&lang=ts"
export * from "./StTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports